import React, {FunctionComponent} from 'react';
import {SvgIcon, SvgIconProps} from "@material-ui/core";

import {ReactComponent as AddIcon} from './theme/svg/icons/add.svg';
import {ReactComponent as AppointmentIcon} from './theme/svg/icons/appointment.svg';
import {ReactComponent as ArrowDownIcon} from './theme/svg/icons/arrow-down.svg';
import {ReactComponent as ArrowLongIcon} from './theme/svg/icons/arrow-long.svg';
import {ReactComponent as ArrowRightIcon} from './theme/svg/icons/arrow-right.svg';
import {ReactComponent as ArrowUpIcon} from './theme/svg/icons/arrow-up.svg';
import {ReactComponent as CalendarIcon} from './theme/svg/icons/calendar.svg';
import {ReactComponent as CloseIcon} from './theme/svg/icons/close.svg';
import {ReactComponent as CorporationIcon} from './theme/svg/icons/corporation.svg';
import {ReactComponent as DashboardIcon} from './theme/svg/icons/dashboard.svg';
import {ReactComponent as DateIcon} from './theme/svg/icons/date.svg';
import {ReactComponent as DeleteIcon} from './theme/svg/icons/delete.svg';
import {ReactComponent as DocumentUploadIcon} from './theme/svg/icons/document-upload.svg';
import {ReactComponent as DownloadIcon} from './theme/svg/icons/download.svg';
import {ReactComponent as DownloadLargeIcon} from './theme/svg/icons/download-large.svg';
import {ReactComponent as DragAndDropDocumentIcon} from './theme/svg/icons/drag-and-drop-document.svg';
import {ReactComponent as DragAndDropImageIcon} from './theme/svg/icons/drag-and-drop-image.svg';
import {ReactComponent as EditIcon} from './theme/svg/icons/edit.svg';
import {ReactComponent as EmptyProfileIcon} from './theme/svg/icons/empty-profile-small.svg';
import {ReactComponent as EraseIcon} from './theme/svg/icons/erase.svg';
import {ReactComponent as EventIcon} from './theme/svg/icons/event.svg';
import {ReactComponent as ExpertIcon} from './theme/svg/icons/expert.svg';
import {ReactComponent as FavouriteIcon} from './theme/svg/icons/favorit.svg';
import {ReactComponent as FavouriteLargeIcon} from './theme/svg/icons/favorit-large.svg';
import {ReactComponent as LogoutIcon} from './theme/svg/icons/logout.svg';
import {ReactComponent as PersonIcon} from './theme/svg/icons/person.svg';
import {ReactComponent as PositionIcon} from './theme/svg/icons/position.svg';
import {ReactComponent as SettingsIcon} from './theme/svg/icons/settings.svg';
import {ReactComponent as SettingsDoneIcon} from './theme/svg/icons/settings-done.svg';
import {ReactComponent as TimeIcon} from './theme/svg/icons/time.svg';
import {ReactComponent as VideoCallIcon} from './theme/svg/icons/video-call.svg';

export type CustomIconName =
  'add'
  | 'appointment'
  | 'arrowDown'
  | 'arrowLong'
  | 'arrowRight'
  | 'arrowUp'
  | 'calendar'
  | 'close'
  | 'corporation'
  | 'dashboard'
  | 'date'
  | 'delete'
  | 'documentUpload'
  | 'download'
  | 'downloadLarge'
  | 'dragAndDropDocument'
  | 'dragAndDropImage'
  | 'edit'
  | 'emptyProfile'
  | 'erase'
  | 'event'
  | 'expert'
  | 'favourite'
  | 'favouriteLarge'
  | 'logout'
  | 'person'
  | 'position'
  | 'settings'
  | 'settingsDone'
  | 'time'
  | 'videoCall';

interface CustomIconProps extends SvgIconProps {
    iconname: CustomIconName
}

const icons: { [unit: string]: FunctionComponent } = {
    add: AddIcon,
    appointment: AppointmentIcon,
    arrowDown: ArrowDownIcon,
    arrowLong: ArrowLongIcon,
    arrowRight: ArrowRightIcon,
    arrowUp: ArrowUpIcon,
    calendar: CalendarIcon,
    close: CloseIcon,
    corporation: CorporationIcon,
    dashboard: DashboardIcon,
    date: DateIcon,
    delete: DeleteIcon,
    documentUpload: DocumentUploadIcon,
    download: DownloadIcon,
    downloadLarge: DownloadLargeIcon,
    dragAndDropDocument: DragAndDropDocumentIcon,
    dragAndDropImage: DragAndDropImageIcon,
    edit: EditIcon,
    emptyProfile: EmptyProfileIcon,
    erase: EraseIcon,
    event: EventIcon,
    expert: ExpertIcon,
    favourite: FavouriteIcon,
    favouriteLarge: FavouriteLargeIcon,
    logout: LogoutIcon,
    person: PersonIcon,
    position: PositionIcon,
    settings: SettingsIcon,
    settingsDone: SettingsDoneIcon,
    time: TimeIcon,
    videoCall: VideoCallIcon
}

const CustomIcon: React.FunctionComponent<CustomIconProps> = (props ) => {
    const icon = icons[props.iconname];

    return (
        <SvgIcon {...props} component={icon}></SvgIcon>
    );
}

export default CustomIcon;